import React from "react";
import { TextField, Grid, Typography } from "@mui/material";

const InvoiceDetailsForm = ({
  editableInvoice,
  handleInputChange,
  isDisabled,
  documentType,
}) => {
  return (
    <>
      <Typography variant="subtitle1" className="mb-2 fw-bold">
        {documentType === "Estimate" ? "Estimate Details" : "Invoice Details"}
      </Typography>
      <Grid container spacing={2} className="mb-3">
        <Grid item xs={12} sm={6}>
          {documentType === "Invoice" ? (
            <TextField
              label="Invoice Number"
              value={editableInvoice.invoiceNumber || ""}
              fullWidth
              variant="filled"
              InputProps={{
                readOnly: isDisabled,
              }}
              disabled={isDisabled}
              onChange={(e) => handleInputChange("invoiceNumber", e.target.value)}
            />
          ) : (
            <TextField
              label="Estimate Number"
              value={editableInvoice.estimateNumber || ""}
              fullWidth
              variant="filled"
              InputProps={{
                readOnly: isDisabled,
              }}
              disabled={isDisabled}
              onChange={(e) => handleInputChange("estimateNumber", e.target.value)}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {documentType === "Invoice" ? (
            <TextField
              label="Invoice Date"
              type="date"
              value={
                editableInvoice.invoiceDate
                  ? new Date(editableInvoice.invoiceDate).toISOString().slice(0, 10)
                  : ""
              }
              fullWidth
              variant="filled"
              InputProps={{
                readOnly: isDisabled,
              }}
              disabled={isDisabled}
              onChange={(e) =>
                handleInputChange("invoiceDate", new Date(e.target.value).toISOString())
              }
            />
          ) : (
            <TextField
              label="Estimate Date"
              type="date"
              value={
                editableInvoice.estimateDate
                  ? new Date(editableInvoice.estimateDate).toISOString().slice(0, 10)
                  : ""
              }
              fullWidth
              variant="filled"
              InputProps={{
                readOnly: isDisabled,
              }}
              disabled={isDisabled}
              onChange={(e) =>
                handleInputChange("estimateDate", new Date(e.target.value).toISOString())
              }
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Due Date"
            type="date"
            value={
              editableInvoice.dueDate
                ? new Date(editableInvoice.dueDate).toISOString().slice(0, 10)
                : ""
            }
            fullWidth
            variant="filled"
            InputProps={{
              readOnly: isDisabled,
            }}
            disabled={isDisabled}
            onChange={(e) =>
              handleInputChange("dueDate", new Date(e.target.value).toISOString())
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Total Amount"
            value={`$${editableInvoice.total}`}
            fullWidth
            variant="filled"
            InputProps={{
              readOnly: true,
              style: {
                fontWeight: "bold",
                color: "green",
              },
            }}
            disabled={isDisabled}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12}>
        <TextField
          label="Email Message"
          value={editableInvoice.emailMessage || ""}
          onChange={(e) => handleInputChange("emailMessage", e.target.value)}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          disabled={isDisabled}
        />
      </Grid>
      <Grid item xs={12} sm={12} sx={{ mt: 2 }}>
        <TextField
          label="Description"
          value={editableInvoice.description || ""}
          onChange={(e) => handleInputChange("description", e.target.value)}
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          disabled={isDisabled}
        />
      </Grid>
    </>
  );
};

export default InvoiceDetailsForm;
